<template>
  <div class="container">
    <LoadingBox v-if="loading" />
    <div class="report" v-if="!loading">
      <div class="cover-letter">
        <div class="cover-letter__top-wave"></div>

        <div class="cover-letter__content">
          <div class="cover-letter__image"></div>
          <h1 class="title is-1" style="marginTop: 4rem;">Feedback Report</h1>
          <h2 class="title is-3" style="marginTop: 1.5rem;">
            {{ report.applicationRef.organizationName }}
          </h2>
          <div class="cover-letter__footer">
            <p>Presented by: </p>
            <h2>Unfunded List</h2>
          </div>
        </div>
        <div class="cover-letter__bottom-wave"></div>
      </div>
      <div class="intro-letter" v-if="introLetter">
        <div class="intro-letter__content">
          <h4 class="title is-4">To: {{ report.applicationRef.organizationName }}</h4>
          <p v-html="introLetter.html" />
        </div>
      </div>
      <div class="evaluations">
        <div class="cover-letter__content">
          <br>
          <br>
          <p>As a refresher, <a :href="report.applicationRef.proposalLink" target='_blank' style="color: blue" >click here</a> to see the proposal you asked us to review </p>
          <br>
        </div>
      </div>
      <div class="evaluations">
        <div class="preparer" v-if="report.universalFeedback">
          <h4 class="title is-4">Report Preparer Comments</h4>
          <div class="commitment box">{{ report.universalFeedback }}</div>
        </div>
        <div
          v-for="(evaluation, index) in validEvaluations"
          :key="evaluation.id"
          class="evaluation"
        >
          <div class="evaluation__top-wave"></div>

          <div class="evaluation__content">
            <div class="evaluation__header">
              <h3 style="marginBottom: 1rem;">Reviewer # {{ index + 1 }}</h3>
              <h2 class="title is-4" style="marginBottom: 0.5rem;">
                <b>{{ evaluation.evaluator.fullName }}</b>
              </h2>
              <p>Background: {{ evaluation.evaluator.evaluatorAffiliation }}</p>
            </div>
            <br>
            <div
              v-for="response in evaluation.responses"
              :key="response.id"
              v-if="response.questionRef.questionType !== 'SCALE' && response.response !== null && response.includeInReport"
              class="evaluation__response"
            >
              <p class="has-text-weight-bold evaluation__response-header">
                {{
                  response.questionRef.questionText !== 'Comments'
                    ? response.questionRef.questionText
                    : response.questionRef.helpText
                }}
              </p>
              <p class="evaluation__response-content break-pars">{{ response.response }}</p>
              <div class="blue-divider"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="commitments" v-if="report.commitmentRefs.length">
        <h4 class="title is-4">Follow-Ups from Evaluators</h4>
        <div
          v-for="commitment in report.commitmentRefs"
          :key="commitment.id"
          class="commitment box"
        >
          <h4 class="has-text-weight-bold">{{ commitment.evaluationRef.evaluatorRef.fullName }}</h4>
          <p>{{ commitment.description }}</p>
        </div>
      </div>
      <div class="files" v-if="endFiles">
        <div class="file" v-for="file in endFiles" :key="file.id">
          <p class="file__html" v-html="file.html" />
          <div>{{ getPDF(file.file, file.id) }}</div>
          <div :id="file.id" style="width: 550px;"></div>
          <br>
          <div :id="file.id + '-jpg'" style="width: 100%;"></div>
        </div>
      </div> 

      <div class="end-page">
        <div class="end-page__top-wave"></div>
        <div class="end-page__icon"></div>
        <div class="end-page__bottom-wave"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Application from '@/services/applications'
import ApplicationReport from '@/services/applicationReports'
import EvaluationResponse from '@/services/evaluationResponses'

import LoadingBox from '@/components/LoadingBox'

export default {
  name: 'ApplicationReportDetail',
  components: {
    LoadingBox,
  },
  data() {
    return {
      loading: true,
      report: null,
      validEvaluations: [],
      files: []
    }
  },
  computed: {
    ...mapState(['userLoggedInStatus', 'user']),
    introLetter() {
      return this.report.fileRefs.find(file => file.introLetter === true)
    },
    endFiles() {
      const returnThis = this.report.fileRefs.filter(file => file.introLetter === false)
      return returnThis
    },
  },
  created() {
    const applicationId = this.$route.params.applicationId
    this.fetchReport(applicationId)
    if(window.AdobeDC) this.pdfAPIReady = true;
  },
  mounted() {
      let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', 'https://documentcloud.adobe.com/view-sdk/main.js')
      document.head.appendChild(recaptchaScript)
      document.onreadystatechange = () => { 
        if (document.readyState == "complete") { 
          setTimeout(function() {
            var i;
            for (i=0; i<thesefiles.length;i++)
            {
              if (thesefiles[i] == null)
              {
              }
              else{
                if (thesefiles[i].includes(".pdf"))
                {
                      const viewerConfig = {
                                              embedMode: "IN_LINE",
                                              defaultViewMode: "FIT_WIDTH",
                                              dockPageControls: false,
                                              showAnnotationTools: false,
                                              showDownloadPDF: false,
                                              showFullScreen: false,
                                              showLeftHandPanel: false,
                                              showPageControls: false,
                                              showPrintPDF: false,
                                              borderless: false
                                          };
                      var adobeDCView = new AdobeDC.View({
                          clientId: "a5a8744a9736418aa7cf0ffc4a88dd75",
                          divId: theseids[i]
                      });
                      adobeDCView.previewFile({
                          content: { location: { url: thesefiles[i] } },
                          /* Pass meta data of file */
                          metaData: {/* file name */fileName: thesefiles[i]}
                      }, viewerConfig);
                }else{
                  var fieldNameElement = document.getElementById(theseids[i]+"-jpg");
                  if (fieldNameElement)
                    {
                      fieldNameElement.innerHTML = '<img src ='+ thesefiles[i] +' width= 100% >';
                    }
                }
              }
            }
                  },2000);
        } 
    }
    },
  methods: {
    getPDF(thisfile, thisid){
      theseids.push(thisid);
      thesejpgids.push(thisid+"-jpg");
      thesefiles.push(thisfile);
    },
    getEvaluationResponses(evaluation) {
      return evaluation.responses.filter(
        response => response.questionRef.questionType !== 'SCALE' && response.response !== null,
      )
    },
    async fetchReport(id) {

      try {
        const report = await Application.api.getApplicationReport(id)
        const evaluations = await Application.api.getEvaluations(id)
        this.report = report
        var test = false;
        if (this.user.organization_ref == null)
        {
          test = true
        }else{
          test = (this.report.applicationRef.organizationName != this.user.organization_ref.name)
        }
        if ((test)&&(this.user.is_staff != true))
        {
          window.open('/applications/','_self')
        }
        const files = await ApplicationReport.api.getReportFiles(this.report.applicationRef.cohort)
        this.files = files

        this.evaluations = evaluations

        const evalWithResponses =  this.evaluations.filter(evaluation => this.getEvaluationResponses(evaluation).length)
        const evalWithOrder = evalWithResponses.filter(evaluation => (evaluation.applicationOrder != null && evaluation.applicationOrder > 0))
        const evalWithoutOrder = evalWithResponses.filter(evaluation => (evaluation.applicationOrder === null || evaluation.applicationOrder === 0))
        this.validEvaluations = evalWithOrder.sort(function(a, b) {
          return a.applicationOrder - b.applicationOrder
        }).concat(evalWithoutOrder)

        this.validEvaluations.forEach((evaluation) => {
          if (evaluation.responses[0].evaluationOrder != null) {
            evaluation.responses.sort(function(a, b) {
              return a.evaluationOrder - b.evaluationOrder
            })
          } else {
            const withoutSection = evaluation.responses.filter(response => response.questionRef.section === null)
            const withSection = evaluation.responses.filter(response => response.questionRef.section != null)

            withSection.sort(function(a, b) {
              const secA = evaluation.sections.filter(section => section.id === a.questionRef.section)
              const secB = evaluation.sections.filter(section => section.id === b.questionRef.section)
              if (secA.length > 0 && secB.length > 0) {
                var n =  secA[0].order - secB[0].order;
              } else {
                var n = 1
              }
              if (n !== 0) {
                return n;
              }
              return b.questionRef.order - a.questionRef.order;
            })
            evaluation.responses = withSection.concat(withoutSection)
          }
        })


        this.validEvaluations = this.validEvaluations.filter((evaluation) => {
          return evaluation.includeInReport
        })

      } catch (err) {
        console.log("error")
        console.log(err)
        window.open('/applications/','_self')
        this.$Alert.alert({
          type: 'error',
          message: `Error loading report`,
          timeout: 6000,
        })
      } finally {
        this.loading = false
      }
    }
  },
}
var theseids =  [];
var thesejpgids =  [];
var thesefiles =  [];
</script>


<style lang="scss" scoped>
 /* montserrat-regular - latin */
@font-face {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  src: url('/fonts/montserrat-v15-latin-regular.eot'); /* IE9 Compat Modes */
  src: local(''),
       url('/fonts/montserrat-v15-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('/fonts/montserrat-v15-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
       url('/fonts/montserrat-v15-latin-regular.woff') format('woff'), /* Modern Browsers */
       url('/fonts/montserrat-v15-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
       url('/fonts/montserrat-v15-latin-regular.svg#Montserrat') format('svg'); /* Legacy iOS */
}
.container {
  width: 100vw;
  margin: 0 !important;
  float: none;
  max-width: none;
  background-color: #f6f6f6;

  -webkit-print-color-adjust: exact;

  @media print {
    size: auto; /* auto is the initial value */
    margin: 0mm; /* this affects the margin in the printer settings */
  }
}

.report {
  width: 100%;
}

.cover-letter {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  background-color: #f6f6f6;

  &__top-wave {
    height: 12rem;
    background-position: left;
    background-repeat: no-repeat;
    background-size: contain;
  }

  &__bottom-wave {
    height: 12rem;
    background-position: right;
    background-repeat: no-repeat;
    background-size: contain;
  }

  &__content {
    display: flex;
    flex-direction: column;
    margin-right: 4rem;
    margin-left: 6rem;

    h1 {
      font-size: 4rem;
      width: 20rem;
    }
  }

  &__image {
    margin-top: 6rem;
    width: 10rem;
    height: 10rem;
    background-image: url('../assets/images/brand-icon.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  &__footer {
    margin-top: 1.5rem;

    p {
      font-family: Poppins;
      font-size: 1rem;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #000000;
    }

    h2 {
      font-family: Poppins;
      font-size: 1.5rem;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 2.21;
      letter-spacing: normal;
      color: #eb6333;
    }
  }
}

.intro-letter {
  height: 100vh;
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #f6f6f6;

  &__content {
    margin-left: 6rem;
    margin-right: 4rem;

    h4 {
      margin-top: 4rem;
      margin-bottom: 2rem;
    }
  }

  &__bottom-wave {
    height: 18rem;
    background-position: right;
    background-repeat: no-repeat;
    background-size: contain;
  }
}

.evaluations {
  page-break-before: always;

  h3 {
    font-family: Poppins;
    font-size: 1.2rem;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #eb6333;
  }
}

.evaluation {
  margin-bottom: 2rem;
  margin-left: 6rem;

  @media print {
    page-break-before: always;
  }

  &__content {
    margin-right: 4rem;
  }

  &__top-wave {
    height: 12rem;
    background-position: right;
    background-repeat: no-repeat;
    background-size: contain;
  }

  &__response {
    word-wrap: break-word;

    @media print {
      page-break-inside: avoid;
      padding-top: 1cm;
      padding-bottom: 0.2cm;
    }
  }

  &__response-header {
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }
}

.commitments {
  padding-top: 2rem;
  margin-left: 6rem;
  margin-right: 4rem;
  min-height: 100vh;

  page-break-before: always;
}

.break-pars {
  white-space: pre-wrap;
}

.commitment {
  padding: 2.5rem;
  white-space: pre-wrap;
  overflow-wrap: break-word;

  @media print {
    page-break-inside: avoid;
  }
}
.preparer {
  margin-left: 6rem;
  margin-right: 4rem;
  margin-bottom: 2rem;
  margin-top: 10rem;
}

.end-page {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  background-color: #70c7da;

  @media print {
    page-break-before: always;
  }

  &__top-wave {
    height: 12rem;
    background-position: right;
    background-repeat: no-repeat;
    background-size: contain;
    margin-top: 0;
    padding-top: 0;
  }

  &__icon {
    margin-top: 10rem;
    margin-bottom: 10rem;
    height: 10rem;
    background-image: url('../assets/images/brand-icon.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  &__bottom-wave {
    height: 11rem;
    background-position: right;
    background-repeat: no-repeat;
    background-size: contain;

    @media print {
      margin: 0mm;
    }
  }
}

.blue-divider {
  height: 1px;
  background-color: #70c7da;
  margin: 2rem 0 0.2rem 0;
}

.file {
  min-height: 100vh;
  margin-left: 6rem;
  margin-right: 4rem;

  &__html {
    padding-top: 2rem;
  }

  @media print {
    page-break-inside: avoid;
    margin-top: 1cm;
  }
}
</style>
